var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLifebuoy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 47.25C36.75 47.25 47.25 36.8438 47.25 24C47.25 11.25 36.75 0.75 24 0.75C11.1562 0.75 0.75 11.25 0.75 24C0.75 36.8438 11.1562 47.25 24 47.25ZM14.25 40.125L19.3125 35.0625C22.2188 36.375 25.6875 36.375 28.5938 35.0625L33.6562 40.125C27.75 43.6875 20.1562 43.6875 14.25 40.125ZM31.5 24C31.5 28.2188 28.125 31.5 24 31.5C19.7812 31.5 16.5 28.2188 16.5 24C16.5 19.875 19.7812 16.5 24 16.5C28.125 16.5 31.5 19.875 31.5 24ZM40.0312 33.75L34.9688 28.6875C36.2812 25.7812 36.2812 22.3125 34.9688 19.4062L40.0312 14.3438C43.5938 20.25 43.5938 27.8438 40.0312 33.75ZM33.6562 7.96875L28.5938 13.0312C25.6875 11.7188 22.2188 11.7188 19.3125 13.0312L14.25 7.96875C20.1562 4.40625 27.75 4.40625 33.6562 7.96875ZM7.875 14.3438L12.9375 19.4062C11.625 22.3125 11.625 25.7812 12.9375 28.6875L7.875 33.75C4.3125 27.8438 4.3125 20.25 7.875 14.3438Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifebuoy);
export default __webpack_public_path__ + "static/media/lifebuoy.fbf7f52b035f03adb865850cd822890b.svg";
export { ForwardRef as ReactComponent };